import { api, ApiRequestConfig } from './api';

export type RemoteWidgetAsset = {
  type: string;
  props: Record<string, string | boolean | number>;
};

export type RemoteWidgetResponse = {
  html: string;
  state: Record<string, unknown>;
  scripts: RemoteWidgetAsset[];
  styles: RemoteWidgetAsset[];
};

export const getRemoteWidget = (widget: string, config: ApiRequestConfig) =>
  api.get<RemoteWidgetResponse>('remote-widget', { widget }, config);
